export const arkLoadingSpinner = (isDarkMode: boolean) => ({
    nm: 'Main Scene',
    ddd: 0,
    h: 500,
    w: 500,
    meta: {
        g: '@lottiefiles/creator 1.44.0'
    },
    layers: [
        {
            ty: 4,
            nm: 'Progress Bar (leader)',
            sr: 1,
            st: 0,
            op: 150,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        0,
                        0
                    ]
                },
                s: {
                    a: 0,
                    k: [
                        100,
                        100
                    ]
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        250,
                        250
                    ]
                },
                r: {
                    a: 1,
                    k: [
                        {
                            o: {
                                x: 0.167,
                                y: 0.167
                            },
                            i: {
                                x: 0.833,
                                y: 0.833
                            },
                            s: [
                                0
                            ],
                            t: 0
                        },
                        {
                            s: [
                                360
                            ],
                            t: 60
                        }
                    ]
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100
                }
            },
            shapes: [
                {
                    ty: 'sh',
                    bm: 0,
                    hd: false,
                    nm: 'Progress Bar',
                    d: 1,
                    ks: {
                        a: 0,
                        k: {
                            c: true,
                            i: [
                                [
                                    -87.47614999999999,
                                    0
                                ],
                                [
                                    0,
                                    -87.47614999999999
                                ],
                                [
                                    87.47614999999999,
                                    0
                                ],
                                [
                                    0,
                                    87.47614999999999
                                ]
                            ],
                            o: [
                                [
                                    87.47614999999999,
                                    0
                                ],
                                [
                                    0,
                                    87.47614999999999
                                ],
                                [
                                    -87.47614999999999,
                                    0
                                ],
                                [
                                    0,
                                    -87.47614999999999
                                ]
                            ],
                            v: [
                                [
                                    0,
                                    -158.5
                                ],
                                [
                                    158.5,
                                    0
                                ],
                                [
                                    0,
                                    158.5
                                ],
                                [
                                    -158.5,
                                    0
                                ]
                            ]
                        }
                    }
                },
                {
                    ty: 'st',
                    bm: 0,
                    hd: false,
                    nm: 'Stroke',
                    lc: 2,
                    lj: 2,
                    ml: 1,
                    o: {
                        a: 0,
                        k: 100
                    },
                    w: {
                        a: 0,
                        k: 32
                    },
                    c: {
                        a: 0,
                        k: !isDarkMode ? [0.3373, 0.8118, 0.8824] : [0, 0.0313725, 0.22352]
                    }
                },
                {
                    ty: 'tm',
                    bm: 0,
                    hd: false,
                    nm: 'Trim Path',
                    e: {
                        a: 0,
                        k: 6
                    },
                    o: {
                        a: 0,
                        k: 0
                    },
                    s: {
                        a: 0,
                        k: 22
                    },
                    m: 1
                }
            ],
            ind: 1
        },
        {
            ty: 4,
            nm: 'Progress Bar (chaser)',
            sr: 1,
            st: 0,
            op: 150,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        0,
                        0
                    ]
                },
                s: {
                    a: 0,
                    k: [
                        100,
                        100
                    ]
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        250,
                        250
                    ]
                },
                r: {
                    a: 1,
                    k: [
                        {
                            o: {
                                x: 0.167,
                                y: 0.167
                            },
                            i: {
                                x: 0.833,
                                y: 0.833
                            },
                            s: [
                                0
                            ],
                            t: 0
                        },
                        {
                            s: [
                                360
                            ],
                            t: 60
                        }
                    ]
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100
                }
            },
            shapes: [
                {
                    ty: 'sh',
                    bm: 0,
                    hd: false,
                    nm: 'Progress Bar',
                    d: 1,
                    ks: {
                        a: 0,
                        k: {
                            c: true,
                            i: [
                                [
                                    -87.47614999999999,
                                    0
                                ],
                                [
                                    0,
                                    -87.47614999999999
                                ],
                                [
                                    87.47614999999999,
                                    0
                                ],
                                [
                                    0,
                                    87.47614999999999
                                ]
                            ],
                            o: [
                                [
                                    87.47614999999999,
                                    0
                                ],
                                [
                                    0,
                                    87.47614999999999
                                ],
                                [
                                    -87.47614999999999,
                                    0
                                ],
                                [
                                    0,
                                    -87.47614999999999
                                ]
                            ],
                            v: [
                                [
                                    0,
                                    -158.5
                                ],
                                [
                                    158.5,
                                    0
                                ],
                                [
                                    0,
                                    158.5
                                ],
                                [
                                    -158.5,
                                    0
                                ]
                            ]
                        }
                    }
                },
                {
                    ty: 'st',
                    bm: 0,
                    hd: false,
                    nm: 'Stroke',
                    lc: 2,
                    lj: 2,
                    ml: 1,
                    o: {
                        a: 0,
                        k: 100
                    },
                    w: {
                        a: 0,
                        k: 32
                    },
                    c: {
                        a: 0,
                        k: !isDarkMode ? [0.502, 1, 0.8588] : [0.3373, 0.8118, 0.8824]
                    }
                },
                {
                    ty: 'tm',
                    bm: 0,
                    hd: false,
                    nm: 'Trim Path',
                    e: {
                        a: 0,
                        k: 0
                    },
                    o: {
                        a: 1,
                        k: [
                            {
                                o: {
                                    x: 0.167,
                                    y: 0.167
                                },
                                i: {
                                    x: 0.833,
                                    y: 0.833
                                },
                                s: [
                                    22
                                ],
                                t: 0
                            },
                            {
                                o: {
                                    x: 0.167,
                                    y: 0.167
                                },
                                i: {
                                    x: 0.833,
                                    y: 0.833
                                },
                                s: [
                                    0
                                ],
                                t: 30
                            },
                            {
                                s: [
                                    22
                                ],
                                t: 60
                            }
                        ]
                    },
                    s: {
                        a: 0,
                        k: 16
                    },
                    m: 1
                }
            ],
            ind: 2
        },
        {
            ty: 4,
            nm: 'Progress Track',
            sr: 1,
            st: 0,
            op: 150,
            ip: 0,
            hd: false,
            ddd: 0,
            bm: 0,
            hasMask: false,
            ao: 0,
            ks: {
                a: {
                    a: 0,
                    k: [
                        0,
                        0
                    ]
                },
                s: {
                    a: 0,
                    k: [
                        100,
                        100
                    ]
                },
                sk: {
                    a: 0,
                    k: 0
                },
                p: {
                    a: 0,
                    k: [
                        250,
                        250
                    ]
                },
                r: {
                    a: 0,
                    k: 0
                },
                sa: {
                    a: 0,
                    k: 0
                },
                o: {
                    a: 0,
                    k: 100
                }
            },
            shapes: [
                {
                    ty: 'sh',
                    bm: 0,
                    hd: false,
                    nm: 'Progress Track',
                    d: 1,
                    ks: {
                        a: 0,
                        k: {
                            c: true,
                            i: [
                                [
                                    -87.47614999999999,
                                    0
                                ],
                                [
                                    0,
                                    -87.47614999999999
                                ],
                                [
                                    87.47614999999999,
                                    0
                                ],
                                [
                                    0,
                                    87.47614999999999
                                ]
                            ],
                            o: [
                                [
                                    87.47614999999999,
                                    0
                                ],
                                [
                                    0,
                                    87.47614999999999
                                ],
                                [
                                    -87.47614999999999,
                                    0
                                ],
                                [
                                    0,
                                    -87.47614999999999
                                ]
                            ],
                            v: [
                                [
                                    0,
                                    -158.5
                                ],
                                [
                                    158.5,
                                    0
                                ],
                                [
                                    0,
                                    158.5
                                ],
                                [
                                    -158.5,
                                    0
                                ]
                            ]
                        }
                    }
                },
                {
                    ty: 'st',
                    bm: 0,
                    hd: false,
                    nm: 'Stroke',
                    lc: 2,
                    lj: 2,
                    ml: 1,
                    o: {
                        a: 0,
                        k: 100
                    },
                    w: {
                        a: 0,
                        k: 32
                    },
                    c: {
                        a: 0,
                        k: !isDarkMode ? [0, 0.0314, 0.2235] : [1, 1, 1]
                    }
                },
                {
                    ty: 'tm',
                    bm: 0,
                    hd: false,
                    nm: 'Trim Path',
                    e: {
                        a: 0,
                        k: 100
                    },
                    o: {
                        a: 0,
                        k: 0
                    },
                    s: {
                        a: 0,
                        k: 0
                    },
                    m: 1
                }
            ],
            ind: 3
        }
    ],
    v: '5.7.0',
    fr: 30,
    op: 60,
    ip: 0,
    assets: []
});
